import { displayValueByDataType } from "#src/utils/display";
import type {
  AttributeDataTypeType,
  CustomAttributeType,
} from "@validereinc/domain";

type DisplayValueOptsType = NonNullable<
  Parameters<typeof displayValueByDataType>[2]
>;

/**
 * Merges display options for a custom-attribute table cell.
 *
 * Group-by headers pass caller `opts` such as `{ emptyText: "(Blank)" }`.
 * Those must combine with `headerRenderOpts` and with `lookupEntityType` for
 * multi-lookup columns so raw IDs still resolve to linked names.
 */
export const getCustomAttributeDisplayOpts = ({
  dataType,
  lookupEntityType,
  headerRenderOpts,
  opts,
}: {
  dataType: AttributeDataTypeType;
  lookupEntityType?: CustomAttributeType["lookup_entity_type"];
  headerRenderOpts?: DisplayValueOptsType;
  opts?: DisplayValueOptsType;
}): DisplayValueOptsType => ({
  ...headerRenderOpts,
  ...opts,
  ...(dataType === "multi-lookup" && lookupEntityType
    ? { lookupEntityType }
    : {}),
});
